import { Typography } from "@mui/material";
import { FormikProps } from "formik";
import { isString } from "lodash-es";
import React from "react";

interface Props {
  name: string;
  formikProps: FormikProps<any>;
}

export const FormikError = ({ formikProps, name }: Props) => {
  const { error, touched } = formikProps.getFieldMeta(name);
  return touched && error && isString(error) ? (
    <Typography variant="caption" color="error">
      {error}
    </Typography>
  ) : null;
};
